import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=318bb9e0"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=318bb9e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports